import { useNavigate, useSearchParams } from 'react-router-dom';

export default function SearchBar() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const value = searchParams.get('q') || '';

  function handleChange(e) {
    const next = e.target.value;
    if (next.length === 0) {
      navigate('/search', { replace: true });
    } else {
      navigate(`/search?q=${encodeURIComponent(next)}`, { replace: true });
    }
  }

  return (
    <div className="FV-searchbar">
      <input
        className="FV-searchbar-input"
        type="search"
        placeholder="Search your library…"
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}
